// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-08-28T13:11:07+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  189390
//    Project:        528
//    Environment:    4218 - master
//    MD5:            d32a9d47b9e412de7c8195dfe426b0bd
//    Signature:      eyJpdiI6IjhGcWdEYVhndUxcL09KWkk1aFJpYzN3PT0iLCJ2YWx1ZSI6IlBKWUtMUThqSldmNW9QTFA3SkV2V1ZRdms4bmVWbnU3UjF5UUQ4VEtxNWdzelwvTlJneEVhUTN0QXAwSTR1THNmY05LK3Z4cmVkbDlBT0JjV3F0ZWhUYTRvU2lGU0o1cmJoT2xpXC96TCtWclVtSDVCb09LM1BTVnF3eXlrand0WWVkQUJTRitvMTd2YWNJV25SR21KTzZNREJ0VXZ5VGMyMHRCSGt4ZXI0YXRwVjVZblhMN0x4MFlDOTI2YnhqWnBiSlZrV0cxQWhcL1U0MGRnMmN4QzVzOGN1YmNMWkhXTE5ENHFOeFwvc21lcGdjcDBPMDdnN3kyQ05hZm9yR3puUlhJbTFmdTltXC9MUmhyN1FPQWFhVjlWYTdDckxEcVBsbnJXRTJiMWFqOStCUWRRNGx5c3lDZ2x3cWNVXC9sR2lpUnZtcDR2c05BZ3VsTGJKYXRrY0tHenAwUlcyTklLa3VSRjY2ZVY1UVwvZ2grUmNFaFZxaCtqckVjNm00aWdWajdOcUNaNWRwQjFyQXBCbDR1RDlxaDJqZ1NnPT0iLCJtYWMiOiJiMzU1ZDA0ODc0Nzc2YThmYmQ2YWY0NjI5ZjEwNjM4ODEwMjIyOWI2ZmJhN2UwODMwMzcyMTMzY2RhZTc1NDJiIn0=
window.ESC_QUANTITY_DISCOUNT = {};
(function (App) {
	App.CUSTOMER = {
		tags: [],
	};
	App.QUANTITY_SELECTOR = "#Quantity";
	App.ACTIVE_MAP = [];
	App.MAP_KEY = "GUEST";
	App.MAP = {
		GUEST: {
			MODEL_1: {
				5: 0.98,
				25: 0.95,
				50: 0.93,
				100: 0.9,
			},
			MODEL_2: {
				10: 0.98,
				25: 0.96,
				50: 0.94,
				100: 0.92,
				250: 0.9,
			},
			MODEL_3: {
				5: 0.97,
				50: 0.95,
				100: 0.93,
				250: 0.9,
				1000: 0.85,
			},
			MODEL_4: {
				2: 0.97,
				5: 0.95,
				10: 0.93,
				25: 0.9,
			},
			MODEL_5: {
				25: 0.97,
				100: 0.95,
				250: 0.93,
				1000: 0.9,
				5000: 0.88,
			},
			MODEL_6: {
				5: 0.98,
				25: 0.97,
				50: 0.96,
				100: 0.95,
			},
			MODEL_7: {
				5: 0.98,
				25: 0.97,
			},
			MODEL_8: {
				2: 0.95,
				5: 0.93,
				10: 0.91,
				25: 0.88,
			},
			MODEL_9: {
				5: 0.9,
				25: 0.8,
				100: 0.72,
				250: 0.65,
				1000: 0.62,
			},
			MODEL_10: {
				2: 0.97,
				5: 0.95,
			},
			MODEL_11: {
				120: 0.97,
				300: 0.95,
				600: 0.93,
				1200: 0.9,
				3000: 0.88,
			},
		},
		LEVEL_1: {
			discount: {
				1: 0.7,
			},
		},
		LEVEL_2: {
			discount: {
				1: 0.8,
			},
		},
		LEVEL_3: {
			discount: {
				1: 0.95,
			},
		},
	};
	App.MAP_ORDER = ["GUEST", "LEVEL_1", "LEVEL_2", "LEVEL_3"];
	App.CUSTOMER_DISCOUNT = {
		LEVEL_1: 0.7,
		LEVEL_2: 0.8,
		LEVEL_3: 0.95,
	};

	App.init = function () {
		this.Common.loadCustomer();
		this.Common.setMap();
		if (this.Common.isProductPage()) {
			this.ProductPage.init();
		}
	};

	App.Common = {
		isProductPage: function () {
			return !!document.body.classList.contains("template-product");
		},

		loadCustomer: function () {
			var customer = document.querySelector("#esc-discounts-customer");
			if (customer) {
				App.CUSTOMER = JSON.parse(customer.innerHTML);
			}
		},

		setMap: function () {
			var activeMapIndex = 0;
			var tag;
			for (var i = 0; i < App.CUSTOMER.tags.length; i++) {
				tag = App.CUSTOMER.tags[i];
				if (App.MAP_ORDER.indexOf(tag) > activeMapIndex) {
					activeMapIndex = App.MAP_ORDER.indexOf(tag);
				}
			}
			App.MAP_KEY = App.MAP_ORDER[activeMapIndex];

			var map = App.MAP_KEY === "GUEST" ? App.MAP["GUEST"] : Object.assign({}, App.MAP["GUEST"], App.MAP[App.MAP_KEY]);

			var values = [];
			for (var k in map) {
				values = [];
				for (var h in map[k]) {
					values.push({ qty: parseInt(h), modifier: map[k][h] });
				}
				App.ACTIVE_MAP.push({
					name: k,
					vals: values.sort(function (a, b) {
						return b.qty - a.qty;
					}),
				});
			}
		},

		getSelectedVariantID: function () {
			const params = new URL(document.location).searchParams;
			const variant = params.get("variant");
			if (variant) {
				return variant;
			} else {
				return document.querySelector(".product-form select option:checked")?.getAttribute("data-variant-id");
			}
		},

		formatMoney: function (money) {
			return Shopify.formatMoney(money).replace("$", "");
		},
	};

	App.ProductPage = {
		variantId: true,

		product: {
			tags: [],
		},

		breaks: null,

		applicableDiscounts: [],

		map: [],

		quantitySelector: null,

		moneyFormat: "${{amount}}",

		onSale: null,

		init: function () {
			if (window.Shopify.money_format) {
				this.moneyFormat = window.Shopify.money_format;
			}

			this.loadProduct();
			this.getQuantityBreaks();
			this.drawPriceCharts(this.product.price);
			this.addCustomerDiscountInfo(this.product.price);

			this.quantitySelector = document.querySelector(App.QUANTITY_SELECTOR);
			this.quantitySelector.addEventListener("change", this.changeDisplayPrice.bind(this));

			document.addEventListener("variant:change", () => {
				this.variantChanged.bind(this)();
			});
			this.variantChanged();
			this.changeDisplayPrice();
		},

		itemOnSale: function () {
			if (!this.onSale === null) {
				return this.onSale;
			}
			var variant = this.getVariant();
			var regularPrice = document.querySelector(".product__price .price-item--regular").innerHTML;
			var salePrice = document.querySelector(".product__price .price-item--sale").innerHTML;
			return regularPrice !== salePrice;
		},

		displayMoney: function (amount) {
			return this.moneyFormat.replace("{{amount}}", amount);
		},

		variantChanged: function () {
			this.variantId = this.getVariantId();
			this.drawPriceCharts(this.getPrice());
			this.addCustomerDiscountInfo(this.getPrice());
			this.changeDisplayPrice();
		},

		addCustomerDiscountInfo: function (price) {
			let exists = document.getElementsByClassName("esc-customer-discount");
			if (exists.length > 0) {
				exists[0].outerHTML = "";
			}

			var containerId = "price";
			var container = document.getElementById(containerId);

			if (container && App.MAP_KEY != "GUEST") {
				let table = document.createElement("table");

				let row = document.createElement("tr");
				let th = document.createElement("th");
				th.innerHTML = "List Price";
				row.appendChild(th);
				let td = document.createElement("td");
				td.innerHTML = this.displayMoney(App.Common.formatMoney(price));
				row.appendChild(td);

				let row2 = document.createElement("tr");
				let th2 = document.createElement("th");
				th2.innerHTML = "You Save";
				row2.appendChild(th2);
				let td2 = document.createElement("td");
				td2.innerHTML = Math.round((1 - App.CUSTOMER_DISCOUNT[App.MAP_KEY]) * 100) + "%";
				row2.appendChild(td2);

				table.appendChild(row);
				table.appendChild(row2);

				table.className = "esc-customer-discount";
				container.appendChild(table);
			}
		},

		getVariantId: function () {
			return parseInt(App.Common.getSelectedVariantID());
		},

		getVariant: function () {
			this.variantId = this.getVariantId();

			for (var i = 0; i < this.product.variants.length; i++) {
				if (this.product.variants[i].id === this.variantId) {
					return this.product.variants[i];
				}
			}

			return this.product.variants[0];
		},

		getPrice: function () {
			if (!this.variantId) {
				return this.product.price;
			}

			var variant = this.getVariant();
			return variant ? variant.price : 0;
		},

		getPriceForQuantity(qty) {
			var price = this.getPrice();
			var bestDiscount = 1;
			var j;
			var values;
			var modifier;

			for (var i = 0; i < this.applicableDiscounts.length; i++) {
				values = this.applicableDiscounts[i].vals;
				for (j = 0; j < values.length; j++) {
					modifier = values[j].modifier;
					if (values[j].qty <= qty) {
						bestDiscount = modifier;
						break;
					}
				}
			}

			if (App.MAP_KEY != "GUEST") {
				bestDiscount = bestDiscount * App.CUSTOMER_DISCOUNT[App.MAP_KEY];
			}

			return price * bestDiscount;
		},

		changeDisplayPrice: function () {
			var price = this.getPriceForQuantity(this.quantitySelector.value);
			var priceElement = this.itemOnSale ? document.querySelector("#price .current-price") : document.querySelector(".product__price .price-item--sale");

			priceElement.innerHTML = this.displayMoney(App.Common.formatMoney(price));
		},

		loadProduct: function () {
			var productJson = document.querySelector("script[id^='ProductJson-']");
			if (productJson) this.product = JSON.parse(productJson.innerHTML);
		},

		getQuantityBreaks: function () {
			for (var i = 0; i < App.ACTIVE_MAP.length; i++) {
				if (this.product.tags.indexOf(App.ACTIVE_MAP[i].name) > -1) {
					this.applicableDiscounts.push(App.ACTIVE_MAP[i]);
				}
			}
		},

		drawPriceCharts: function (price) {
			var containerId = "esc-quantity-discount-container";
			var container = document.getElementById(containerId);
			if (!container) {
				container = document.createElement("div");
				container.setAttribute("id", containerId);

				var el = document.querySelector("form[data-product-id]");
				el.appendChild(container);
			}
			container.innerHTML = "";

			for (var i = 0; i < this.applicableDiscounts.length; i++) {
				this.drawPriceChart(this.applicableDiscounts[i], price, container);
			}
		},

		drawPriceChart: function (band, price, container) {
			var table = document.createElement("table");
			var row = document.createElement("tr");
			var cell;

			cell = document.createElement("td");
			cell.innerHTML = "QUANTITY";
			row.appendChild(cell);

			cell = document.createElement("td");
			cell.innerHTML = "PRICE PER UNIT";
			row.appendChild(cell);
			table.appendChild(row);

			for (var i = band.vals.length - 1; i > -1; i--) {
				row = document.createElement("tr");
				cell = document.createElement("td");
				cell.innerHTML = band.vals[i].qty + " +";
				row.appendChild(cell);

				cell = document.createElement("td");

				var discount = band.vals[i].modifier;
				if (App.MAP_KEY != "GUEST") {
					discount = band.vals[i].modifier * App.CUSTOMER_DISCOUNT[App.MAP_KEY];
					cell.innerHTML = '<span class="theme-money struck-out-price">' + this.displayMoney(App.Common.formatMoney(price * band.vals[i].modifier)) + "</span> ";
				}
				cell.innerHTML += this.displayMoney(App.Common.formatMoney(price * discount));
				row.appendChild(cell);

				table.appendChild(row);
			}

			table.classList.add("esc-quantity-discount-table");
			container.appendChild(table);
		},
	};

	document.addEventListener("DOMContentLoaded", App.init.bind(App));
})(window.ESC_QUANTITY_DISCOUNT || {});
